<template>
  <div class="loader">
    <div class="loader__inner">
      <div class="loader__text">
        Loading<span v-for="dot in dotCount" :key="dot">.</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

const dotCount = ref(3)
const dotInterval = ref(null)

onMounted(() => {
  dotInterval.value = setInterval(loadDots, 500)
})

onUnmounted(() => {
  clearInterval(dotInterval.value)
})

function loadDots() {
  if (dotCount.value === 3) {
    dotCount.value = 1
  } else {
    dotCount.value += 1
  }
}
</script>

<style lang="sass">
.loader
  position: fixed
  top: 0
  left: 0
  z-index: 1
  height: 100vh
  width: 100vw
  background-color: #000000bf
  display: flex
  justify-content: center
  align-items: center

  &__inner
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center

  &__image
    max-width: 240px

  &__text
    font-size: 24px

</style>